export default "__VITE_ASSET__d23b2613__"